import { useEffect } from 'react';

const MetaHelper = ({ title, description }) => {
    useEffect(() => {
        // 1. Update the Tab Title
        document.title = title || "CPR Constructions | Elite Gated Communities";

        // 2. Update the Meta Description (for SEO)
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", description || "Premium luxury apartments in Tirupati by CPR Constructions.");
        }
    }, [title, description]);

    return null; // This component doesn't show anything on the screen
};

export default MetaHelper;